<div [formGroup]="form">
  <div class="page-header">
    <h1>Employment Income</h1>
  </div>
  @if (form.parent.get('expenseInformation.haveLostEmploymentIncomeExpenses') == undefined || form.parent.get('expenseInformation.haveLostEmploymentIncomeExpenses').value === false) {
    <span>
      <section>
        <p>You have not requested income benefit, if this is correct continue to the next page. If you are requesting this benefit, go back to Expense & Loss Information.</p>
      </section>
    </span>
  }
  @if (form.parent.get('expenseInformation.haveLostEmploymentIncomeExpenses').value === true) {
    <span>
      <p>This section provides information regarding employment information. This information is necessary if you are requesting benefits for lost employment income.</p>
      <section>
        <h2 class="blue-header">Income Loss Information</h2>
        <app-field label="Were you employed when the crime occured?" [required]="true" [valid]="isFieldValid('wereYouEmployedAtTimeOfCrime')" errorMessage="Please select whether you were employed when the crime occurred">
          <label class="inline-label">
            <input type="radio" [value]="CRMBoolean.True" name="wereYouEmployedAtTimeOfCrime" formControlName="wereYouEmployedAtTimeOfCrime">
            <span>Yes</span>
          </label>
          <label class="inline-label">
            <input type="radio" [value]="CRMBoolean.False" name="wereYouEmployedAtTimeOfCrime" formControlName="wereYouEmployedAtTimeOfCrime">
            <span>No</span>
          </label>
        </app-field>
        @if (form.get('wereYouEmployedAtTimeOfCrime').value === CRMBoolean.True) {
          <div>
            <app-field label="Were you at work at the time of the incident?" [required]="form.get('wereYouEmployedAtTimeOfCrime').value === CRMBoolean.True" [valid]="isFieldValid('wereYouAtWorkAtTimeOfIncident')" errorMessage="Please select whether you were at work">
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.True" name="wereYouAtWorkAtTimeOfIncident" formControlName="wereYouAtWorkAtTimeOfIncident">
                <span>Yes</span>
              </label>
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.False" name="wereYouAtWorkAtTimeOfIncident" formControlName="wereYouAtWorkAtTimeOfIncident">
                <span>No</span>
              </label>
            </app-field>
          </div>
        }
        @if (form.get('wereYouAtWorkAtTimeOfIncident').value === CRMBoolean.True) {
          <div>
            <app-field label="Have you applied to WorkSafe BC?" [required]="form.get('wereYouAtWorkAtTimeOfIncident').value === CRMBoolean.True" [valid]="isFieldValid('haveYouAppliedToWorkSafe')" errorMessage="Please select an option">
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.True" name="haveYouAppliedToWorkSafe" formControlName="haveYouAppliedToWorkSafe">
                <span>Yes</span>
              </label>
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.False" name="haveYouAppliedToWorkSafe" formControlName="haveYouAppliedToWorkSafe">
                <span>No</span>
              </label>
            </app-field>
          </div>
        }
        @if (form.get('haveYouAppliedToWorkSafe').value === CRMBoolean.True) {
          <div class="row">
            <div class="col-md-6">
              <app-field label="WorkSafe BC Claim #" [required]="form.get('haveYouAppliedToWorkSafe').value === CRMBoolean.True" [valid]="isFieldValid('workersCompensationClaimNumber')" errorMessage="Please include a WorkSafe BC Claim Number">
                <input class="form-control" name="workersCompensationClaimNumber" type="text" formControlName="workersCompensationClaimNumber">
              </app-field>
            </div>
          </div>
        }
        <div>
          <app-field label="As a result of any crime-related injuries, did you miss work?" [required]="true" [valid]="isFieldValid('didYouMissWorkDueToCrime')" errorMessage="Please select whether you missed work">
            <label class="inline-label">
              <input type="radio" [value]="CRMBoolean.True" name="didYouMissWorkDueToCrime" formControlName="didYouMissWorkDueToCrime">
              <span>Yes</span>
            </label>
            <label class="inline-label">
              <input type="radio" [value]="CRMBoolean.False" name="didYouMissWorkDueToCrime" formControlName="didYouMissWorkDueToCrime">
              <span>No</span>
            </label>
          </app-field>
        </div>
        @if (form.get('didYouMissWorkDueToCrime').value === CRMBoolean.True) {
          <div>
            <app-field label="Are you currently off work?" [tooltipReference]="stillOfWorkTemplate" [required]="form.get('didYouMissWorkDueToCrime').value === CRMBoolean.True" [valid]="isFieldValid('areYouStillOffWork')" errorMessage="Please select whether you are currently off work">
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.True" name="areYouStillOffWork" formControlName="areYouStillOffWork">
                <span>Yes</span>
              </label>
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.False" name="areYouStillOffWork" formControlName="areYouStillOffWork">
                <span>No</span>
              </label>
            </app-field>
            <ng-template #stillOfWorkTemplate>
              <p><strong>Still off work</strong></p>
              <p>If not, please select no and enter the start and end dates of the missed work period. If you remain off work, select yes and enter the date of your first work day missed.</p>
            </ng-template>
          </div>
          <div>
            <app-field label="Please provide date(s) of work missed" [valid]="form.get('areYouStillOffWork').value === CRMBoolean.True?isFieldValid('daysWorkMissedStart'):isFieldValid('daysWorkMissedStart') && isFieldValid('daysWorkMissedEnd')" [required]="form.get('didYouMissWorkDueToCrime').value === CRMBoolean.True" errorMessage="Please enter a valid range for missed work">
              <div class="date-container">
                <div class="start-date-container">
                  <app-date-field [control]="form.get('daysWorkMissedStart')" [max]="today" (change)="daysWorkMissedStartChange()"></app-date-field>
                </div>
                @if (form.get('areYouStillOffWork').value === CRMBoolean.False) {
                  <div class="end-date-container">
                    <span class="end-date-span">
                      <span class="tick-span"> - </span>
                      <app-date-field [control]="form.get('daysWorkMissedEnd')" class="full-width" [min]="minEndDate" [max]="today" (change)="daysWorkMissedEndChange()"></app-date-field>
                    </span>
                  </div>
                }
              </div>
              <!-- <input type="text" [max]="today" (dateChange)="daysWorkMissedStartChange($event)" class="form-control date-picker" formControlName="daysWorkMissedStart" placeholder="yyyy-mm-dd" [matDatepicker]="daysWorkMissedStartPicker" (focus)="daysWorkMissedStartPicker.open()" (click)="daysWorkMissedStartPicker.open()" readonly>
              <mat-datepicker #daysWorkMissedStartPicker></mat-datepicker>
              <span *ngIf="form.get('areYouStillOffWork').value === CRMBoolean.False">
                <span> - </span>
                <input type="text" [max]="today" [min]="minEndDate" (dateChange)="daysWorkMissedEndChange($event)" class="form-control date-picker" formControlName="daysWorkMissedEnd" placeholder="yyyy-mm-dd" [matDatepicker]="daysWorkMissedEndPicker" (focus)="daysWorkMissedEndPicker.open()" (click)="daysWorkMissedEndPicker.open()" readonly>
                <mat-datepicker #daysWorkMissedEndPicker></mat-datepicker>
              </span> -->
            </app-field>
          </div>
          <div>
            <app-field label="As a result of any crime-related injuries, did you lose wages?" [tooltipReference]="lostWagesTemplate" [required]="form.get('didYouMissWorkDueToCrime').value === CRMBoolean.True" [valid]="isFieldValid('didYouLoseWages')" errorMessage="Please select whether you lost wages">
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.True" name="didYouLoseWages" formControlName="didYouLoseWages">
                <span>Yes</span>
              </label>
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.False" name="didYouLoseWages" formControlName="didYouLoseWages">
                <span>No</span>
              </label>
            </app-field>
            <ng-template #lostWagesTemplate>
              <p><strong>Lost wages or income</strong></p>
              <p>If you are claiming for lost wages or income, we will need to verify your employment</p>
            </ng-template>
          </div>
          @if (form.get('didYouLoseWages').value === CRMBoolean.True) {
            <div>
              <app-field label="Social Insurance Number (SIN)" [required]="form.get('didYouLoseWages').value === CRMBoolean.True" [valid]="isFieldValid('sin')" errorMessage="Please enter your SIN">
                <input class="form-control sin-input" mask='000 000 000' maxlength="11" type="text" formControlName="sin">
              </app-field>
            </div>
          }
        }
        @if (form.get('didYouLoseWages').value === CRMBoolean.True) {
          <h2 class="blue-header">Employer Information</h2>
          <p>If you are claiming for lost wages or income, we will need to verify your employment</p>
          <div>
            <app-field label="Are you self employed?" [required]="form.get('didYouLoseWages').value === CRMBoolean.True" [valid]="isFieldValid('areYouSelfEmployed')" errorMessage="Please select whether you are self employed">
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.True" name="areYouSelfEmployed" formControlName="areYouSelfEmployed">
                <span>Yes</span>
              </label>
              <label class="inline-label">
                <input type="radio" [value]="CRMBoolean.False" name="areYouSelfEmployed" formControlName="areYouSelfEmployed">
                <span>No</span>
              </label>
            </app-field>
          </div>
          @for (item of form.get('employers')['controls']; track item; let i = $index) {
            <div class="employers" formArrayName="employers">
              <div [formGroupName]="i" class="employer">
                @if (form.get('areYouSelfEmployed').value !== CRMBoolean.True) {
                  <div>
                    <app-field label="If you are requesting benefits for lost wages, may we contact your employer?" [required]="form.get('areYouSelfEmployed').value !== CRMBoolean.True" [valid]="isMyControlValid(item.get('contactable'))" errorMessage="Please select whether we can contact your employer">
                      <label class="inline-label">
                        <input type="radio" [value]="CRMBoolean.True" formControlName="contactable" (change)="contactableChange(true, i)">
                        <span>Yes</span>
                      </label>
                      <label class="inline-label">
                        <input type="radio" [value]="CRMBoolean.False" formControlName="contactable" (change)="contactableChange(false, i)">
                        <span>No</span>
                      </label>
                    </app-field>
                  </div>
                }
                @if (form.get('employers')['controls'].length>1) {
                  <div>
                    <a href="javascript:void(0);" (click)="removeEmployer(i)" class="float-right">
                      <i class="fas fa-trash-alt"></i> Delete Employer
                    </a>
                    <h2>{{item.get('employerName').value|titlecase}}</h2>
                  </div>
                }
                <h3>Name &amp; Phone Number</h3>
                <div class="row">
                  <div class="col-md-6">
                    <app-field label="Name of Company / Organization" [required]="item.get('contactable').value === CRMBoolean.True" [valid]="isMyControlValid(item.get('employerName'))" errorMessage="Please enter a company name">
                      <input type="text" class="form-control" formControlName="employerName">
                    </app-field>
                  </div>
                  <div class="col-md-6">
                    <app-field label="Email Address" [required]="false" [valid]="isMyControlValid(item.get('employerEmail'))" errorMessage="Please enter your employer's email address">
                      <input type="text" class="form-control" (blur)="trimEmail(item.get('employerEmail'))" formControlName="employerEmail" maxlength="100">
                    </app-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <app-field label="Contact First Name" [required]="false" [valid]="isMyControlValid(item.get('employerFirstName'))" errorMessage="Please include your employer's given name">
                      <input type="text" class="form-control" formControlName="employerFirstName">
                    </app-field>
                  </div>
                  <div class="col-md-6">
                    <app-field label="Contact Last name" [required]="false" [valid]="isMyControlValid(item.get('employerLastName'))" errorMessage="Please include your employer's last name">
                      <input type="text" class="form-control" formControlName="employerLastName">
                    </app-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <app-field label="Phone Number of Company/Contact Person" [required]="item.get('contactable').value === CRMBoolean.True" [valid]="isMyControlValid(item.get('employerPhoneNumber'))" errorMessage="Please enter a contact phone number">
                      @if (item.get('employerAddress.country').value === 'Canada' || item.get('employerAddress.country').value === 'United States of America') {
                        <input type="text" mask='(000) 000 0000' class="form-control" formControlName="employerPhoneNumber">
                      } @else {
                        <input class="form-control" type="text" formControlName="employerPhoneNumber" digitOnly>
                      }
                    </app-field>
                  </div>
                  <div class="col-md-6">
                    <app-field label="Fax" [required]="false" [valid]="isMyControlValid(item.get('employerFax'))" errorMessage="Please enter a valid fax number">
                      @if (item.get('employerAddress.country').value === 'Canada' || item.get('employerAddress.country').value === 'United States of America') {
                        <input type="text" mask='(000) 000 0000' class="form-control" formControlName="employerFax">
                      } @else {
                        <input class="form-control" type="text" formControlName="employerFax" digitOnly>
                      }
                    </app-field>
                  </div>
                </div>
                <h3>Mailing Address</h3>
                <app-address (change)="setEmployerPhoneValidators(item)" [group]="item.get('employerAddress')" [showChildrenAsRequired]="item.get('contactable').value === CRMBoolean.True"></app-address>
              </div>
            </div>
          }
          <button class="btn btn-secondary mb-3" (click)="addEmployer()">Add Additional Employer</button>
          @if (form.get('areYouSelfEmployed').value === CRMBoolean.True) {
            <p>To verify your employment and income loss, CVAP will require additional documents (e.g. invoices, receipts, pay stubs, contracts, bank statements, tax assessments) that will confirm you were working and receiving income at the time of the offence.</p>
            <p>Please upload any documents you have available <strong>File size limit:</strong> one file cannot exceed 2MB and all files uploaded to application cannot exceed 3.5MB</p>
            <app-file-uploader [formGroup]="form" [formType]="formType" [documents]="form.get('documents')"></app-file-uploader>
          }
        }
      </section>
    </span>
  }
</div>